<template>
  <a-card class="m-t-10" :bordered="false">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      出库操作
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" >
      <a-form-item label="物流公司">
        <a-select v-model:value="form.logistics_name" style='width: 380px;' placeholder='请选物流公司'>
          <a-select-option v-for='item in logisticsList' :key='item.name' :value="item.name">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10'  @click='form.logistics_name=null'>清空</a-button>
      </a-form-item>
      <a-form-item label="物流单号">
        <a-input style="width: 380px;" v-model:value="form.logistics_code" placeholder='请输入物流单号'></a-input>
      </a-form-item>
      <a-form-item label="扫码类型" name='type'>
        <a-radio-group v-model:value="form.type" @change='form.code = ""'>
          <a-radio :value="1">正常扫码</a-radio>
          <a-radio :value="2">回退扫码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="扫描二维码" name='code' help='录入的二维码不是最高级别，系统将自动进行拆箱操作，把关联的上级二维码无效化'>
        <a-input style="width: 380px;margin-right: 10px;" v-model:value="form.code" @pressEnter='scanCode'></a-input>
        <a-button class='m-r-10' type="primary" @click='scanCode' :loading='submitLoading'>添加</a-button>
        <a-tooltip placement='right'>
          <template #title>
            <p>1、点击“添加”后数据直接保存。如果使用扫描枪设备，不需要点击“添加”按钮，设备扫描完成会自动保存。</p>
            <p>2、使用扫描枪扫描时注意先将“光标”放到输入框中。（鼠标点一下输入框）</p>
            <p>3、程序自带提示音，会根据录入结果提示对应的声音，方便盲扫，请确保电脑带有声音播放功能。</p>
          </template>
          <InfoCircleOutlined class="fz-18" />
        </a-tooltip>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 2}">
        <a-checkbox v-model:checked="form.is_gift">扫码商品标记为赠品</a-checkbox>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 2}" v-if='showResult'>
        <a-card>
          <p class="s_lin_h30">扫码结果：</p>
          <p class="s_lin_h30">
            <span v-if='form.type == 1'>{{resultCode == 0 ? '出库成功！':'出库失败！'}}</span>
            <span v-else>{{resultCode == 0 ? '回退成功！':'回退失败！'}}</span>
          </p>
          <p class="s_lin_h30" v-if='resultCode != 0'>失败原因：</p>
          <p class="s_lin_h30" v-if='resultCode != 0'>{{resultMsg}}</p>
        </a-card>
      </a-form-item>
      <a-descriptions :column='1' title="出库单详情">
        <a-descriptions-item label="收货信息">{{orderData.to}}</a-descriptions-item>
        <a-descriptions-item label="发货仓库">{{orderData.warehouse_position_name}}</a-descriptions-item>
        <a-descriptions-item label="出库单号">{{orderData.out_warehousing_sn}}</a-descriptions-item>
      </a-descriptions>
      <p class="fz-16 s_font_b m-t-20">商品详情</p>
      <a-table class='m-t-20' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns'
        :data-source='orderData.product'>
        <template v-slot:gift_name="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
            </template>
            <template #description>
              <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="link" @click='showCode = true;productSkuSn=record.product_sku_sn;productId=record.product_id'>查看出货二维码</a-button>
        </template>
      </a-table>
      <div class="m-t-25">
        <a-button class="width-100 m-r-20" block @click="onCancel">取消出库</a-button>
        <a-button class="width-100 m-r-20" block type="primary" @click="onSubmit('all')">确定出库</a-button>
        <a-button type="primary" @click="onSubmit('part')">确定部分出库</a-button>
      </div>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer="null">
    <template #title>
      <span class="fz-16">出库二维码</span>
      <span class="fz-14 s_c999">（进行拆箱发货的小标，删除后关联的中标和大标依然无效）</span>
    </template>  
    <warehouseOutCode v-on:select='codeConfirm' :id='$route.query.id' :productId='productId' :productSkuSn='productSkuSn' :showAction='false'></warehouseOutCode>
  </a-modal>
  <a-modal :keyboard="false" centered v-model:visible="showError" :closable='false'>
    <p class="fz-18 s_font_b text-ac m-b-20">二维码有误，无法发货</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { generateNumber } from "@/utils/utils";
  import warehouseOutCode from './components/warehouseOutCode.vue' 
  import store from "@/store";
  import { getOutWarehousingMore,outScanCode,setOutWarehousing,closeOutWarehousing,setOutWarehousingGift }  from "@/api/antiFleeing";
  import { getExpressList }  from "@/api/order";
  let defForm = {
    sn: '',
    part: 0,
    logistics_name: null,
    logistics_code: '',
    type:1,
    code:'',
    is_gift:0
  };
  export default {
    components: { LeftOutlined,InfoCircleOutlined,warehouseOutCode },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const state = reactive({
        submitLoading:false,
        orderData:{},
        labelCol: {span: 2},
        wrapperCol: {span: 12},
        info: store.state.user.info,
        goodList:[],
        productId:'',
        productSkuSn:'',
        showCode:false,
        showResult:false,
        resultCode:'',
        resultMsg:'',
        logisticsList:[],
        rules: {
          type:[
            { required: true,  message: '请选择扫码类型',type:'number'}
          ],
          code:[
            { required: true,  message: '二维码不能为空'}
          ]
        },
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "数量",
            dataIndex: "out_warehousing_num",
            key: "out_warehousing_num",
          },
          {
            title: "出库数量",
            dataIndex: "out_warehousing_real_num",
            key: "out_warehousing_real_num",
          },
          {
            title: "操作",
            key: "action",
            slots: { customRender: "action" }
          }
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      // 获取物流公司
      const getLogistics = async () => {
        let res = await getExpressList({keyword: '',page: 1,limit: 100,}).then(res => res.data);
        if (iscode(res)) {
          state.logisticsList = res.data.data;
        } else {
          message.error(res.msg);
        }
      }
      //获取详情
      const initData = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getOutWarehousingMore( $route.query.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.orderData = res.data;
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //取消
      const onCancel = () =>{
        $Modal.confirm({
          centered: true,
          title: '退出出库？',
          content: '退出后扫码出库商品将取消出库，进行拆箱发货的中标和大标依然无效',
          async onOk() {
            const hide = message.loading("正在加载中...", 0);
            let res = await closeOutWarehousing( state.orderData.out_warehousing_sn ).then((res) => res.data).catch(error => error);
            if (iscode(res)) {
              $router.go(-1)
            } else {
              message.error(res.msg);
            }
            setTimeout(hide);
          }
        })
      }
      //出货二维码操作
      const codeConfirm = async(e) =>{
        var setting = [e.code_batch_sn+'_'+e.code_sn+'_'+e.code_type+'_'+e.is_gift];
        const hide = message.loading("正在加载中...", 0);
        let res = await setOutWarehousingGift( {id:state.orderData.out_warehousing_sn,setting:setting} ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      //扫码
      const scanCode = () =>{
        ruleForm.value.validate().then(async() => {
          const hide = message.loading("正在加载中...", 0);
          state.submitLoading = true;
          let res = await outScanCode({ 
            code:form.value.code,
            sn:$route.query.id,
            type:form.value.type,
            is_gift:form.value.is_gift ? 1:0
          }).then((res) => res.data).catch(error => error);
          state.resultCode = res.code
          state.resultMsg = res.msg
          state.showResult = true
          form.value.code = ''
          initData();
          setTimeout(hide);
          state.submitLoading = false;
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      //提交
      const onSubmit = (text) => {
        $Modal.confirm({
          centered: true,
          title: text == 'all'?'确定出库？':'确定部分出库？',
          content: text == 'all'?'':'确定后剩余没有出货的商品将生成一张新出货单',
          async onOk() {
            const hide = message.loading("正在加载中...", 0);
            let res = await setOutWarehousing({ 
              part:text == 'all' ? 0 : 1,
              id:$route.query.id,
              logistics_name:form.value.logistics_name,
              logistics_code:form.value.logistics_code
            }).then((res) => res.data).catch(error => error);
            if (iscode(res)) {
              message.success(res.msg);
              setTimeout(() => {
                $router.go(-1);
              }, 2000);
            } else {
              message.error(res.msg);
            }
            setTimeout(hide);
          }
        })
      };
      onMounted(() => {
        getLogistics();
        initData();
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        onSubmit,
        onCancel,
        scanCode,
        codeConfirm
      };
    },
  };
</script>